import { HttpService } from './http.service';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { NGXLogger } from "ngx-logger";

export interface UpdateUserNameAndGroupItem {
  userId: number;
  groupNumberId?: number | null;
  oldGroupId?: number | null;
  newGroupId?: number | null;
  newUserName?: string;
  deleteUser: boolean;
  deleteGroupNumber: boolean;
}

export interface GetFilterUserListRequest {
  profileId?: number | null;
  qualityElementId?: number | null;
  qualityLevels?: number[];
  searchText?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
  pageSize?: number | null;
  pageNum?: number | null;
  userGroupId?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class UsersUsersService {

  constructor(private http: HttpService, private logger: NGXLogger) { }

  public getIndex(userGroupId?: number | null): Observable<any> {
    if (userGroupId === undefined || userGroupId === null) {
      return this.http.getFromApi('/UsersUsers/Index');
    }

    const params = new URLSearchParams();
    params.append('id', userGroupId.toString());
    return this.http.getFromApi(`/UsersUsers/Index?${params.toString()}`);
  }

  public getFilterUserList(model: GetFilterUserListRequest): Observable<any> {
    const params = new URLSearchParams();

    if (model.profileId !== undefined && model.profileId !== null) {
      params.append('profileId', model.profileId.toString());
    }
    if (model.qualityElementId !== undefined && model.qualityElementId !== null) {
      params.append('qualityElementId', model.qualityElementId.toString());
    }
    if (model.qualityLevels && model.qualityLevels.length > 0) {
      model.qualityLevels.forEach((level) => params.append('qualityLevels', level.toString()));
    }
    if (model.searchText) {
      params.append('searchText', model.searchText);
    }
    if (model.sortColumn) {
      params.append('sortColumn', model.sortColumn);
    }
    if (model.sortDirection) {
      params.append('sortDirection', model.sortDirection);
    }
    if (model.pageSize !== undefined && model.pageSize !== null) {
      params.append('pageSize', model.pageSize.toString());
    }
    if (model.pageNum !== undefined && model.pageNum !== null) {
      params.append('pageNum', model.pageNum.toString());
    }

    return this.http.getFromApi(`/UsersUsers/GetFilterUserList?${params.toString()}`);
  }

  public downloadUserData(userGroupId?: number | null): Observable<any> {
    const idSegment = userGroupId != null ? `/${userGroupId}` : '';
    return this.http.postToApiFile(`/usersusers/downloaduserdata${idSegment}`, '{}');
  }

  public validateSimpleUpdateUserData(fileData: string, fileName: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("fileData", fileData);
    formData.append("fileName", fileName);
    return this.http.postFormDataToApi(`/usersusers/validatesimpleupdateuserdata`, formData).pipe(
      filter(event => event instanceof HttpResponse),
      map((response: HttpResponse<any>) => response.body)
    );
  }

  public deleteUsersCheck( data: UpdateUserNameAndGroupItem[]): Observable<any> {
    const body = JSON.stringify( data );
    return this.http.postToApi('/usersusers/deleteuserscheck', body);
  }

  public updateUsers(data: UpdateUserNameAndGroupItem[], deletePuzzelId: boolean = false): Observable<any> {
    const body = JSON.stringify({ data, deletePuzzelId });
    return this.http.postToApi('/usersusers/updateusers', body);
  }

  public importUserSimpleUpdateList(fileData: string, fileName: string, colsInFile: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append("fileData", fileData);
    formData.append("fileName", fileName);
    formData.append("colsInFile", colsInFile);
    return this.http.postFormDataToApi(`/usersusers/importusersimpleupdatelist`, formData).pipe(
      filter(event => event instanceof HttpResponse),
      map((response: HttpResponse<any>) => response.body)
    );
  }

  getUnblockableUserList(userGroupId?: number | null): Observable<any> {
    if (userGroupId === undefined || userGroupId === null) {
      return this.http.getFromApi('/usersusers/getgroupnumbers');
    }

    const params = new URLSearchParams();
    params.append('id', userGroupId.toString());
    return this.http.getFromApi(`/usersusers/getgroupnumbers?${params.toString()}`);
  }
}
